import { render } from "./list-supplier.vue?vue&type=template&id=6b24fab6&scoped=true"
import script from "./list-supplier.vue?vue&type=script&lang=js"
export * from "./list-supplier.vue?vue&type=script&lang=js"

import "./list-supplier.vue?vue&type=style&index=0&id=6b24fab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b24fab6"]])

export default __exports__